import { render, staticRenderFns } from "./DepositOrderEdit.vue?vue&type=template&id=1ba838a6&"
import script from "./DepositOrderEdit.vue?vue&type=script&lang=js&"
export * from "./DepositOrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports